<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="ticket-edit-container__footer">
	<div class="ticket-edit-container__footer-left-grid-item">
		<span *ngIf="!isPlanned && !isStarted" class="light-toggle">
			<span automationId="planTicket">Plan</span>
			<mat-slide-toggle
				automationId="planActualSlider"
				[formControl]="isActualizedControl"
			></mat-slide-toggle>
			<span automationId="actualTicket">Actual</span>
		</span>
		<button
			[disabled]="!showActualizedToggle || isReadOnly"
			*ngIf="(isPlanned && showMoreDetailsButton) || (isStarted && showMoreDetailsButton)"
			automationId="ticketUpdateStatus"
			(click)="actualizeClicked($event)"
			class="legacy-button btn--white"
		>
			{{ actualizedLabel }}
		</button>
	</div>
	<!-- editable view (planned, actualizing) -->
	<div class="ticket-edit-container__footer-right-grid-item ticket-edit-footer-right">
		<button (click)="cancelClicked()" class="legacy-button btn--white" automationId="cancelTicket">
			Cancel
		</button>
		<button
			automationId="saveTicket"
			[disabled]="!formDirty || !formValid"
			(click)="save()"
			class="legacy-button btn--blue"
		>
			{{ saveLabel }}
		</button>
	</div>
</div>
